module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "trailer",
    class: _vm.trailerClasses
  }, [_vm._l((_vm.root.components), function(terciary, terciaryIdx) {
    return _c('div', {
      key: 'terciary-' + terciaryIdx,
      staticClass: "tertiary",
      class: _vm.topLevelClasses(terciary)
    }, [_c('ShippingLvlHeader', {
      attrs: {
        "parent": _vm.root,
        "idx": terciaryIdx,
        "readOnly": _vm.readOnly,
        "showCarbon": _vm.showCarbon,
        "level": _vm.topLevel
      }
    }), _vm._v(" "), _vm._l((terciary.components), function(secondary, secondaryIdx) {
      return _c('div', {
        key: 'secondary-' + secondaryIdx,
        staticClass: "secondary",
        class: _vm.secondTopLevelClasses
      }, [_c('ShippingLvlHeader', {
        attrs: {
          "parent": terciary,
          "idx": secondaryIdx,
          "readOnly": _vm.readOnly,
          "showCarbon": _vm.showCarbon,
          "level": _vm.secondTopLevel
        }
      }), _vm._v(" "), _vm._l((secondary.components), function(primary, primaryIdx) {
        return _c('div', {
          key: 'primary-' + primaryIdx,
          staticClass: "primary primary-color"
        }, [_c('ShippingLvlHeader', {
          attrs: {
            "parent": secondary,
            "idx": primaryIdx,
            "readOnly": _vm.readOnly,
            "showCarbon": _vm.showCarbon,
            "level": 1
          }
        })], 1)
      }), _vm._v(" "), (!_vm.twolevels && !_vm.readOnly) ? _c('ShippingLvlAddButton', {
        attrs: {
          "component": secondary,
          "level": 1
        }
      }) : _vm._e()], 2)
    }), _vm._v(" "), (!_vm.readOnly) ? _c('ShippingLvlAddButton', {
      attrs: {
        "component": terciary,
        "level": _vm.secondTopLevel
      }
    }) : _vm._e()], 2)
  }), _vm._v(" "), (!_vm.readOnly) ? _c('ShippingLvlAddButton', {
    attrs: {
      "component": _vm.root,
      "level": _vm.topLevel
    }
  }) : _vm._e()], 2), _vm._v(" "), (!_vm.readOnly && !_vm.externalModal) ? _c('v-shipping-lvl-modal') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba1e096"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shippinglvls/ShippingLvls.vue
// module id = 707
// module chunks = 0